import React, {useState, useEffect} from "react"
import Select from "react-select"
import {FormattedMessage, injectIntl} from "react-intl"
import Integrations from "../../integration/Integrations.jsx"
import FeeService from "../../state/fee/FeeService"
import {isError} from "../../state/helpers/Error"

type Props = {
    integrationKey: string,
    shippingMethod: shippingMethodOption[],
    selectionCallback: (selectedShippingMethod: string) => object,
}

const ExternalShippingMethodSelect = (props: Props) => {
    const {integrationKey, selectionCallback} = props
    const selectedOption = formatShippingMethodOption(props.shippingMethod)

    const [options, setOptions] = useState<shippingMethodOption[]>([])

    useEffect(() => {
        let isMounted = true
        FeeService.RetrieveExternalShippingMethods(integrationKey).then(res => {
            if (isMounted && !isError(res)) {
                const shippingMethods = res as []
                setOptions(shippingMethods.map(sm => formatShippingMethodOption(sm)))
            }
        })
        return () => {
            isMounted = false
        }
    }, [])

    return (
        <div className={"form-group row"}>
            <div className="col-2 col-form-label text-align-right">
                <FormattedMessage
                    id="fee.form.edit.shipping_method.external_shipping_method_label"
                    defaultMessage="External shipping method for {integrationLogo}"
                    values={{
                        integrationLogo: Integrations.getIntegrationLogoImage(integrationKey, "75")
                    }}
                />
            </div>

            <div className="col-10">
                <Select
                    name={"external-shipping-method-select"}
                    value={selectedOption}
                    onChange={selectedOption => selectionCallback(selectedOption.shippingMethod)}
                    options={options}
                />
            </div>
        </div>
    )
}

type shippingMethodOption = {
    value?: string
    label?: string
    shippingMethod?: string

}
const formatShippingMethodOption = (shippingMethod): shippingMethodOption  => {
    if (!shippingMethod) {
        return {}
    }

    return {
        value: shippingMethod.id,
        label: shippingMethod.title,
        shippingMethod: shippingMethod,
    }
}

export default injectIntl(ExternalShippingMethodSelect)


// WEBPACK FOOTER //
// ./src/settings/fees/ExternalShippingMethodSelect.component.tsx